import { RepositoryFactory } from '@/repository/RepositoryFactory'

const OrderRepository = RepositoryFactory.get('order')

export default {
  methods: {
    async getRememberReason(key) {
      this.statusOptions = localStorage.getItem('order_statuses') ? JSON.parse(localStorage.getItem('order_statuses')) : (await OrderRepository.getFullStatusList()).data.data
      if (!localStorage.getItem('order_statuses')) localStorage.setItem('order_statuses', JSON.stringify(this.statusOptions))
      const rememberReason = this.statusOptions.find(n => n.key === key)
      return rememberReason ? rememberReason.is_remember_reason_enabled : false
    },
  },
}
